import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from '../utils/locale';
import { formatMinutesAsHours } from '../utils/classifiedHoursDisplay';
import {
  segmentNetMinutes,
  taskCompletedNetMinutes,
  taskLunchMinutes
} from '../utils/taskCheckInTime';

function TaskCheckInHistory({ checkIns }) {
  const { t } = useTranslation(['tasks']);
  const historyCheckIns = useMemo(() => {
    if (!Array.isArray(checkIns) || checkIns.length === 0) {
      return [];
    }
    return [...checkIns].sort(
      (a, b) => new Date(a.check_in_time) - new Date(b.check_in_time)
    );
  }, [checkIns]);

  const totalMinutes = taskCompletedNetMinutes(historyCheckIns);
  const lunchTotal = taskLunchMinutes(historyCheckIns);

  if (historyCheckIns.length === 0) {
    return null;
  }

  return (
    <div className="task-detail-section card">
      <h3 className="task-section-label">{t('tasks:checkInsHistory')}</h3>
      {totalMinutes != null && (
        <div className="check-in-history-total">
          <p className="task-time-display task-time-total">
            {t('tasks:totalTimeSpentHistory', { time: formatMinutesAsHours(totalMinutes) })}
          </p>
          {lunchTotal > 0 && (
            <p>{t('tasks:totalLunchMinutesHistory', { minutes: lunchTotal })}</p>
          )}
        </div>
      )}
      {historyCheckIns.map((checkIn) => {
        const isOpen = !checkIn.check_out_time;
        const segmentMinutes = isOpen ? null : segmentNetMinutes(checkIn);

        return (
          <div
            key={checkIn.id}
            className={`check-in-item${isOpen ? ' check-in-item--active' : ''}`}
          >
            <p><strong>{checkIn.user_name}</strong></p>
            <p>{t('tasks:photoCheckIn', { datetime: formatDateTime(checkIn.check_in_time) })}</p>
            {isOpen ? (
              <p className="check-in-active-label" role="status">{t('tasks:checkInActive')}</p>
            ) : (
              <>
                <p>{t('tasks:checkOutHistory', { datetime: formatDateTime(checkIn.check_out_time) })}</p>
                <p>{t('tasks:timeSpentHistory', { time: formatMinutesAsHours(segmentMinutes) })}</p>
                {checkIn.lunch_minutes > 0 && (
                  <p>{t('tasks:lunchMinutesHistory', { minutes: checkIn.lunch_minutes })}</p>
                )}
                {checkIn.summary && (
                  <p>{t('tasks:summaryHistory', { summary: checkIn.summary })}</p>
                )}
              </>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default TaskCheckInHistory;
